import React from "react";
function NotFound() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #ffa07a 0%, #8ecae6 100%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <h1 style={{ fontSize: "5rem", color: "#c70039", fontWeight: "bold" }}>404</h1>
      <div style={{ fontSize: "1.5rem", color: "#232a36", marginTop: "14px" }}>Sorry, page not found.</div>
    </div>
  );
}
export default NotFound;